import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@/main.tsx';
import userRepository from '@/api/repositories/userRepository/UserRepository.ts';
import type { User } from '$/models/User.d.ts';

const useUserUpdate = (refetch = true) => {
  const mutationFn = async (request: Parameters<typeof userRepository.update>) => {
    return updateAction(...request);
  };

  return useMutation({
    mutationFn,
    onSuccess: (data) => {
      if (data) {
        queryClient.setQueryData(['user', data.id], data);
      }

      if (refetch) {
        void queryClient.invalidateQueries({ queryKey: ['users'] });
        void queryClient.invalidateQueries({ queryKey: ['user'] });
      }
    },
  });
};

export default useUserUpdate;

async function updateAction(...request: Parameters<typeof userRepository.update>): Promise<User> {
  const { data, error } = await userRepository.update(...request);

  if (error) throw new Error(error.message);

  return data;
}
